import { useContext } from 'react'
import { CurrencyContext } from 'components/Hook/CurrencyContext'
import { CurrencyExchangeRateContext } from 'components/Hook/CurrencyExchangeRateContext'

export const useFinalPrice = (price: number) => {
  const currency = useContext(CurrencyContext)
  const rates = useContext(CurrencyExchangeRateContext)
  return { amount: Math.round(price * (rates[currency] ?? 1)), currency }
}

export const getFinalPrice = (
  price: number,
  currency: string,
  rates: Record<string, number>
) => {
  const rate = rates[currency]
  return rate ? Math.round(price * rate) : price
}
